import React, { useState, useRef, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import {
    updateItemInfo,
    setItemErrors,
    updateItemDisplayInfo,
    setItemWarnings
} from '../../../actions/items';
import { Regex, scrollIntoView } from '../../../utills.js';
import InputWithMovingLabel from 'jd-library/InputWithMovingLabel';
import Form from 'jd-library/Form';
import FormDate from 'jd-library/FormDate';
import ToggleBtnGroup from 'jd-library/ToggleBtnGroup';
import Dropdown from 'jd-library/Dropdown';
import { showToastMessage } from '../../../actions/toastmessage';
import style from './item-expiry.scss';

const ItemExpiry = (props) => {
    const [expiryBy, toggleExpiryBy] = useState(props.itemInfo.expiryBy || 'manufacturingDate');
    let bestBeforeRef = useRef(null);
    let dateOptions = [{
        label: 'Days',
        key: 'days'
    }, {
        label: 'Months',
        key: 'months'
    }, {
        label: 'Years',
        key: 'years'
    }];

    const handleChange = (e, key) => {
        let tempVal = '';
        if (typeof(e.currentTarget.value) == "string" && !/^\d{0,5}$/.test(e.currentTarget.value)) {
            return;
        }
        else if (typeof(e.currentTarget.value) != "string"){
            tempVal = '' + e.currentTarget.value;
            if (!/^\d{0,5}$/.test(tempVal)){
                return;
            }
        }
        props.updateItemInfo({ [key]: e.currentTarget.value });
        props.setItemErrors({ [key]: "" })
    }

    const validate = (value, formattedDate, activeTab) => {
        const currentDate = new Date();
        if(value){
            currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds())
            //Ignore time param while comparing two dates.
        }
        let dateTab = activeTab || expiryBy;
        let errorMsg = "";
        let warnMsg = '';
        if (dateTab == "expiryDate") {
            props.updateItemDisplayInfo({formattedExpDate: formattedDate});
            if (value == "" || value == null) {
                errorMsg = "Please Enter a Valid Expiry Date";
            } else if (currentDate > value && (formattedDate && !formattedDate.includes("Y"))) {
                warnMsg = "Product has Already Expired";
                errorMsg = warnMsg;
            } else if (currentDate.getDate() == value.getDate() && currentDate.getMonth() == value.getMonth() && currentDate.getFullYear() == value.getFullYear() && (formattedDate && !formattedDate.includes("Y"))) {
                warnMsg = "Please note that the product will expire today";
                errorMsg = warnMsg;
            }
            else if (value.getDate && isNaN(value.getDate()) && (formattedDate && !formattedDate.includes("Y"))) {
                errorMsg = "Please Enter Valid Date";
            }
            props.setItemWarnings({ expiryDate: warnMsg});
            props.setItemErrors({ expiryDate: errorMsg });
            return {isError: !!errorMsg};
        }
        if (dateTab == "manufacturingDate") {
            props.updateItemDisplayInfo({formattedManufDate: formattedDate});
            if(props.itemInfo.bestBefore) {
                if (value == "" || value == null) {
                    errorMsg = "Please Enter Manufacturing Date";
                } else if (currentDate < value && (formattedDate && !formattedDate.includes("Y"))) {
                    warnMsg = "You have Entered Future Date as Manufacturing Date";
                    errorMsg = warnMsg;
                }
                else if (value.getDate && isNaN(value.getDate()) && (formattedDate && !formattedDate.includes("Y"))) {
                    errorMsg = "Please Enter Valid Date";
                }
            }else if(value){
                errorMsg = "Please Enter Best Before";
                props.setItemErrors({bestBefore: errorMsg});
                return {isError: errorMsg};
            }
            props.setItemWarnings({ manufacturingDate: warnMsg});
            props.setItemErrors({ manufacturingDate: errorMsg });
            if(props.itemInfo.bestBefore && (value == "" || !value)){
                validateBestBeforeDate({warnMsg: warnMsg, currentManufacturingDate: '', errorMsg: errorMsg});
                
            } 
            else if(props.itemInfo.bestBefore)
            {

                validateBestBeforeDate({warnMsg: warnMsg, currentManufacturingDate: value});
            }
            return {isError: !!errorMsg};
        }
    }
    const getDateObj = (dateString) => {
        if(dateString)
        {
            var dateParts = dateString.split('/');
            // month is 0-based, that's why we need dataParts[1] - 1
            var dateObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            return(dateObj);
        }
    }
    const validateBestBeforeDate = (params={}) => {
        let {unit, warnMsg, currentManufacturingDate, errorMsg} = params;
        var bestBeforeInDays = Number(props.itemInfo.bestBefore);
        var currentDate = new Date();
        var warningMsg = warnMsg || '';
        var bestBeforeUnit = unit || props.itemInfo.bestBeforeUnit || 'months';
        if(bestBeforeUnit == 'months'){
            bestBeforeInDays = bestBeforeInDays * 30;
        }else if(bestBeforeUnit == 'years'){
            bestBeforeInDays = bestBeforeInDays * 365;
        }

        if(props.itemInfo.manufacturingDate || currentManufacturingDate){
            var manufDateObj = getDateObj(props.itemInfo.manufacturingDate);
            if(currentManufacturingDate){
                manufDateObj = currentManufacturingDate;
            }

            var expDateByBestBefore = new Date();
            expDateByBestBefore.setTime( manufDateObj.getTime() + bestBeforeInDays * 86400000 );
            if(currentDate.getDate()==expDateByBestBefore.getDate() && currentDate.getMonth()==expDateByBestBefore.getMonth() && currentDate.getFullYear()==expDateByBestBefore.getFullYear()){
                warningMsg = "Warning: Please note that the product will expire today.";
            }else if(currentDate > expDateByBestBefore){
                warningMsg = "Warning: Product has Already Expired.";
            }else if(currentDate < manufDateObj && (manufDateObj && !props.itemInfo.manufacturingDate.includes("Y"))){
                warningMsg = "You have Entered Future Date as Manufacturing Date";
            }
            
            if(errorMsg){
                warningMsg = '';
                props.setItemWarnings({ manufacturingDate: '' });
                props.setItemErrors({ manufacturingDate: errorMsg });
            } 
            // else {
            //     props.setItemWarnings({ manufacturingDate: warningMsg });
            //     props.setItemErrors({ manufacturingDate: warningMsg });
            // }
        } 
    }

    const validateOnSave = useCallback(() => {
        if(expiryBy == 'manufacturingDate'){
            return validate(getDateObj(props.itemInfo.manufacturingDate), props.itemInfo.manufacturingDate, 'manufacturingDate');
        }else if(expiryBy == 'expiryDate'){
            return validate(getDateObj(props.itemInfo.expiryDate), props.itemInfo.expiryDate, 'expiryDate');
        }
    },[props.itemInfo])

    useEffect(() => {
        props.updateFunc({validateDates: () => validateOnSave()})
    },[validateOnSave])

    useEffect(() => {
        if(props.itemInfo.manufacturingDate && expiryBy == 'manufacturingDate'){
            validate(getDateObj(props.itemInfo.manufacturingDate), props.itemInfo.manufacturingDate, 'manufacturingDate');
        }else if(props.itemInfo.expiryDate && expiryBy == 'expiryDate'){
            validate(getDateObj(props.itemInfo.expiryDate), props.itemInfo.expiryDate, 'expiryDate');
        }
    }, [])

    return (
        <div className={`${style['product-expiry-container']} ${style['product-expiry-container-omni']}`}>
            <div className='toggle-container'>
                <div className='expiryby-label'>Product Expiry By</div>
                <ToggleBtnGroup
                    selectedValue={expiryBy}
                    onToggle={(e, value) => {
                        toggleExpiryBy(value);
                        props.setItemErrors({[value]: ""})
                        props.updateItemInfo({ expiryBy: value });
                        if(value == 'manufacturingDate' && !props.itemInfo.manufacturingDate && props.itemInfo.bestBefore) {
                            validate(getDateObj(props.itemInfo.manufacturingDate), props.itemInfo.manufacturingDate, value);
                        }
                        if(props.itemInfo.manufacturingDate && props.itemInfo.expiryDate){
                            validate(getDateObj(props.itemInfo[value]), props.itemInfo[value], value);
                        }
                    }}
                >
                    <ToggleBtnGroup.Btn className={style['input-grp-btn']} value='manufacturingDate'>
                        Manufacturing Date
                    </ToggleBtnGroup.Btn>
                    <ToggleBtnGroup.Btn className={style['input-grp-btn']} value='expiryDate'>
                        Expiry Date
                    </ToggleBtnGroup.Btn>
                </ToggleBtnGroup>
            </div>
            <div className='date-container'>
                <Form>
                    <FormDate
                        label={expiryBy == 'manufacturingDate' ? 'Manufacturing Date' : 'Expiry Date'}
                        iconClass='icon-Calendar'
                        onDateChange={(event, obj, formattedDate) => {
                            if(props.session.viaOmni){
                                if(expiryBy == 'manufacturingDate'){
                                    props.updateItemInfo({ manufacturingDate: formattedDate});
                                } else{
                                    props.updateItemInfo({ expiryDate: formattedDate});
                                }
                            } else{
                                props.updateItemInfo({ manufacturingDate: formattedDate, expiryDate: formattedDate, isApplicableExpDate: true });
                            }
                            validate(obj, formattedDate);
                        }}
                        dateformat='dd/mm/yyyy'
                        errorMessage={props.errors[expiryBy] || props.warnings[expiryBy]}
                        isMobile={props.deviceData.isMobile}
                        onBlur={(event,obj,date,isValid)=>{ if(!isValid && !props.session.viaOmni) props.setItemErrors({ [expiryBy]: "Please Enter Valid Date" })}}
                        variant={props.errors.manufacturingDate || props.errors.expiryDate ? (props.session.viaOmni?'withMovingLabel':"invalid") : ''}
                        warning={props.warnings[expiryBy]}
                        startDate={(expiryBy == 'manufacturingDate') ? props.itemInfo.manufacturingDate : props.itemInfo.expiryDate}
                    ></FormDate>
                </Form>
            </div>
            {expiryBy == 'expiryDate' ? null :
                <div className='best-before-container'>
                    <InputWithMovingLabel
                        value={props.itemInfo.bestBefore}
                        ref={bestBeforeRef}
                        label='Best Before'
                        holderClass='best-before-input'
                        errorMessage={props.errors.bestBefore}
                        input={{
                            value: props.itemInfo.bestBefore || '',
                            onFocus: (e) => {
                                e.currentTarget && scrollIntoView(e.currentTarget);
                            },
                            onChange: e => { handleChange(e, 'bestBefore') },
                            onBlur: e => {
                                if (!e.currentTarget.value) {
                                    if(props.itemInfo.manufacturingDate)
                                        props.setItemErrors({ bestBefore: "Please Enter Best Before" });
                                }else{
                                    validateBestBeforeDate();
                                }
                            },
                            type: props.deviceData.isIPhone ? 'number' : 'tel'
                        }}
                    />
                    <Dropdown
                        className={style['dropdown-div']}
                        optionList={dateOptions}
                        onChange={(e, value) => {
                            props.updateItemInfo({ bestBeforeUnit: e.key })
                            if(props.itemInfo.bestBefore)
                                validateBestBeforeDate({unit: e.key});
                        }}
                        placeholder='Select Period'
                        value={props.itemInfo.bestBeforeUnit || 'months'}
                    ></Dropdown>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state,ownProps) => {
    return {
        session: state.session,
        deviceData: state.deviceData,
        itemInfo: ownProps?.itemInfo || state.items.itemInfo,
        errors: state.items.errors,
        warnings: state.items.warnings
    };
};


const mapDispatchToProps= (dispatch, ownProps)=>{
    const cb={
        // updateItemInfo,
        setItemErrors:(...e)=>setItemErrors(...e)(dispatch),
        updateItemDisplayInfo:(...e)=>updateItemDisplayInfo(...e)(dispatch),
        setItemWarnings:(...e)=>setItemWarnings(...e)(dispatch),
        showToastMessage:(...e)=>showToastMessage(...e)(dispatch),
    }
    if(!ownProps.updateItemInfo){
        cb.updateItemInfo=(...e)=>updateItemInfo(...e)(dispatch)
    }
    return cb
}
export default connect(mapStateToProps, mapDispatchToProps)(ItemExpiry);